import { IS_AUTO_TEST_HIDE } from 'reactApp/appHelpers/configHelpers';
import { aiSetFakedoor } from 'reactApp/appHelpers/featuresHelpers/features/aiSetFakedoor';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserStorageActions } from 'reactApp/modules/user/userStorage';
import { store as reduxStore } from 'reactApp/store';
import { renderAiSetFakedoorModal, renderAiSetOkModal } from 'reactApp/ui/AiSetFakedoorModal/AiSetFakedoorModal.helper';
import { sendDwh } from 'reactApp/utils/ga';
import { call, put } from 'redux-saga/effects';
import { select } from 'typed-redux-saga';

const PROMO_ID = 'ai-set-promo';
const PROMO_SHOW_COUNT = `${PROMO_ID}-count`;
const PERIOD_IN_DAYS = 2;
const MAX_SHOWN_COUNT = 3;

const sendRadar = (action: 'show' | 'click' | 'close') =>
    sendDwh({
        eventCategory: 'modal',
        action,
        dwhData: { name: 'fake_ai_functions' },
    });

// НЕ ИСПОЛЬЗОВАТЬ: в большинстве случаев это приведет к багам
// promoShown должен отправляться в onShow, а removePromo – в onClose
// (и в onClick иногда)
function markPromoShown() {
    reduxStore.dispatch(promoShown(EPromoType.aiSetAb));
    storeHelper.markAsShown(PROMO_ID);
    reduxStore.dispatch(removePromo(EPromoType.aiSetAb));
}

export function* initAiSetFakedoorPromo() {
    const storage = yield* select(getCurrentStorage);
    const { isHome } = getStorage(storage);
    const isPaidUser = yield* select(UserSelectors.isPaidUser);
    const isBizUser = yield* select(UserSelectors.isBizUser);
    const shownCount = yield put(UserStorageActions.get(PROMO_SHOW_COUNT)) || 0;

    if (shownCount >= MAX_SHOWN_COUNT) {
        return;
    }

    const periodPassed = storeHelper.getValue(PROMO_ID) && storeHelper.isPassed(PROMO_ID, { daysCount: PERIOD_IN_DAYS });

    if (periodPassed) {
        storeHelper.clearStore(PROMO_ID);
    }

    if (!aiSetFakedoor || !isHome || IS_AUTO_TEST_HIDE || isBizUser || isPaidUser || storeHelper.getValue(PROMO_ID)) {
        return;
    }

    yield put(
        addPromoToShowQueue({
            type: EPromoType.aiSetAb,
            promoId: PROMO_ID,
            onClick: () => {
                markPromoShown();
                reduxStore.dispatch(UserStorageActions.set(PROMO_SHOW_COUNT, MAX_SHOWN_COUNT + 1));
                renderAiSetOkModal();
                sendRadar('click');
            },
            onShow: () => {
                markPromoShown();
                sendRadar('show');
            },
            onClose: () => {
                markPromoShown();
                reduxStore.dispatch(UserStorageActions.set(PROMO_SHOW_COUNT, MAX_SHOWN_COUNT + 1));
            },
            onDismiss: () => {
                sendRadar('close');
            },
        })
    );
}

export function* showAiSetFakedoorPromo() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.aiSetAb));

    if (promo && aiSetFakedoor) {
        const { onShow, onClick, onClose, onDismiss } = promo;

        yield call(renderAiSetFakedoorModal, { onShow, onClick, onClose, onDismiss, variant: aiSetFakedoor });
    }
}
